import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomJoinRuleMessageProps {
  message: IMatrixMessage;
  className?: string;
}

const joinRuleMap: Record<string, string> = {
  invite: '仅邀请可加入',
  public: '公开房间',
  knock: '敲门加入',
  restricted: '受限加入',
};

export const RoomJoinRuleMessage = ({ message, className = '' }: RoomJoinRuleMessageProps) => {
  const sender = message.sender;
  const joinRule = message.content.join_rule;
  const text = joinRuleMap[joinRule] || joinRule;
  return (
    <div
      className={`room-join-rule-message ${className}`}
      style={{
        color: '#fff',
        background: '#0288d1',
        borderRadius: 6,
        padding: '8px 12px',
        fontWeight: 500,
        display: 'inline-block',
        maxWidth: '100%',
      }}
    >
      {sender ? `${sender} 修改了房间加群规则为「${text}」` : `房间加群规则被修改为「${text}」`}
    </div>
  );
}; 